import { AnchorButton } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-scavenger-hunt.png";
import { DayDefinition } from "../DayDefinition.js";

/**
 * Class Scavenger_Hunt
 *
 * Represents the Scavenger Hunt card.
 */
export class Scavenger_Hunt extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-lightbrown2022";

	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "scavenger-hunt";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "In-the-House Scavenger Hunt";

		this.content = <ContentEN />;
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Chasse au trésor maison";
		this.content = <ContentFR />;
	}
}

/**
 * The English content for the card.
 *
 * @returns The English content.
 */
function ContentEN() {
	return (
		<>
			<p className="hl:whitespace-pre-line">
				{`The kids have pent up energy
					They’re running down the halls
					Give it another 5 minutes
					And they’ll be bouncing off the walls!
					It’s time to give them a task
					So they can simmer down a little
					Send them on this scavenger hunt,
					There’s something to find in each riddle
					Split into two teams
					The most important rule of the game
					Is to put everything back
					To exactly from where it came`}
			</p>
			<div className="hl:flex hl:flex-col hl:items-center hl:[&_img]:mb-6 hl:[&_img]:max-w-[300px]">
				<img
					alt=""
					src="https://rootree.ca/wp-content/uploads/2022/12/ScavengerHunt-EN.jpg"
				/>
				<AnchorButton
					className={"hl:no-underline"}
					colour={"white"}
					download
					href="https://rootree.ca/wp-content/uploads/2022/12/ScavengerHunt-EN.pdf"
					target="_blank"
				>
					Download PDF
				</AnchorButton>
			</div>
		</>
	);
}

/**
 * The French content for the card.
 *
 * @returns The French content.
 */
function ContentFR() {
	return (
		<>
			<p className="hl:whitespace-pre-line">
				{`Tous les enfants ont de l'énergie à revendre
					Se précipitant dans les couloirs à toute allure.
					Donnez-leur encore 5 minutes
					Et ils rebondiront sur les murs !
					C’est le moment idéal de leur confier une mission
					Pour qu'ils puissent se relaxer un peu.
					Proposez-leur une
					Chasse au trésor !
					Et ils révéleront les énigmes cachées en chaque lieu.
					Séparez-les en deux équipes.
					La règle numéro 1
					Étant de replacer chaque chose
					À l'endroit précis d’où elle vient.`}
			</p>
			<div className="hl:flex hl:flex-col hl:items-center hl:[&_img]:mb-6 hl:[&_img]:max-w-[300px]">
				<img
					alt=""
					src="https://rootree.ca/wp-content/uploads/2022/12/ScavengerHunt-FR.jpg"
				/>
				<AnchorButton
					className={"hl:no-underline"}
					colour={"white"}
					download
					href="https://rootree.ca/wp-content/uploads/2022/12/ScavengerHunt-FR.pdf"
					target="_blank"
				>
					Téléchargez le PDF
				</AnchorButton>
			</div>
		</>
	);
}
